import _head from 'lodash/head'
import _size from 'lodash/size'

class Process {
  constructor () {
    this.handlers = []
  }

  addHandler = (callback) => {
    this.handlers.push(callback)
    return this
  };

  next = nextIndex => (...params) => {
    if (nextIndex >= _size(this.handlers)) {
      return undefined
    }
    const nextHandler = this.handlers[nextIndex]
    return nextHandler(this.next(nextIndex + 1), ...params)
  };

  run = (...params) => {
    const firstHandler = _head(this.handlers)
    if (!firstHandler) {
      return undefined
    }
    const nextIndex = 1
    return firstHandler(this.next(nextIndex), ...params)
  };
}

export default Process
